import { StatusBadge, cn } from "../../shared/ui";
import type { WorkItemStatus, WorkItemType } from "../../shared/types/api";
import { STATUS_LABELS, STATUS_TONE, TYPE_GLYPH, TYPE_LABELS, TYPE_TONE } from "./workItemVocabulary";

const GLYPH_TONE: Record<WorkItemType, string> = {
  EPIC: "bg-violet-100 text-violet-700",
  USER_STORY: "bg-emerald-100 text-emerald-700",
  TECHNICAL_TASK: "bg-brand-100 text-brand-700",
  BUG: "bg-red-100 text-red-700",
  SPIKE: "bg-amber-100 text-amber-700",
  SUBTASK: "bg-ink-100 text-ink-600",
  ANALYSIS: "bg-brand-100 text-brand-700",
  DEMO_PREPARATION: "bg-violet-100 text-violet-700",
  MIGRATION: "bg-amber-100 text-amber-700",
  SERVER_WORK: "bg-brand-100 text-brand-700",
  CLIENT_SERVICE: "bg-emerald-100 text-emerald-700",
  MEETING: "bg-ink-100 text-ink-600",
};

/**
 * The type marker used everywhere a work item appears in a list.
 *
 * <p>A square glyph rather than a word, because in a dense list the type needs to be identifiable
 * in peripheral vision while the title is what is actually being read. The full word is on the
 * tooltip and on the detail page, where there is room for it.
 */
export function WorkItemTypeBadge({ type }: { type: WorkItemType }) {
  return (
    <span
      title={TYPE_LABELS[type]}
      aria-label={TYPE_LABELS[type]}
      className={cn(
        "inline-grid h-5 w-5 shrink-0 place-items-center rounded font-mono text-xs font-semibold",
        GLYPH_TONE[type],
      )}
    >
      {TYPE_GLYPH[type]}
    </span>
  );
}

export function WorkItemStatusBadge({ status }: { status: WorkItemStatus }) {
  return <StatusBadge tone={STATUS_TONE[status]}>{STATUS_LABELS[status]}</StatusBadge>;
}

export function WorkItemTypeLabel({ type }: { type: WorkItemType }) {
  return <StatusBadge tone={TYPE_TONE[type]}>{TYPE_LABELS[type]}</StatusBadge>;
}
